<template>
  <div>
    <v-layout row wrap>
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <v-btn icon @click="openBox()" right absolute>
            <v-icon>unfold_more</v-icon>
          </v-btn>

          <h1 class="text-info font-size-18">
            Regularidade<strong> Fiscal e Trabalhista</strong>
          </h1>
        </div>
      </v-flex>
    </v-layout>
    
    
<v-layout row wrap v-show="showBox">
  <v-flex infoDados>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="model.regularidadeFiscTrab"
        :hide-actions="true"
        class="elevation-1"
      >    
        <template slot="items" slot-scope="props">          
          <tr>
            <td class="text-xs-right"><strong class="text-primary">{{retornaEnumDescricao("tipoDocumento",props.item.tipDocumento)}}</strong></td>
            <td class="text-xs-left">{{props.item.numDocumento}}</td>
            <td class="text-xs-left" 
                :class="{ 'texto-positiva-vermelha': deveSerVermelho(props.item) }">
              {{ retornaEnumDescricao("situacaoDoc", props.item.situacaoDoc) }}
            </td>

            <td class="text-xs-center">{{props.item.dtEmissao | dataFormatada}}</td>
            <td class="text-xs-center" v-bind:class="{'dataVencida':verificaDataVencida(props.item.dtVencimento)}">{{props.item.dtVencimento | dataFormatada}}</td>
            <td class="text-xs-left">{{props.item.codControle}}</td>
            <td class="text-xs-center naoImprimir">
              
  <a 
    v-show="props.item.arquivoUpload && props.item.arquivoUpload !== 'Não Encontrado'"
  >

  <v-icon 
  :color="(
   props.item.regularidadeFiscTrabSituacao === 2
      ? 'blue'
      : (props.item.regularidadeFiscTrabSituacao === 1)
        ? 'red'
        : 'grey'
  )"
  :disabled="!(
    String(props.item.arquivoUpload).includes('https') || 
    (props.item.regularidadeFiscTrabSituacao === 1 && String(props.item.arquivoUpload).includes('.pdf'))
  )"
  @click.native="handleIconClick(props.item.arquivoUpload, props.item.regularidadeFiscTrabSituacao)"
>
  attach_file
</v-icon>
  </a>
</td>

          </tr>
          <!-- Nova linha solicitada no ticket 161107 -->
          <tr v-if="model.regularidadeFiscTrab[model.regularidadeFiscTrab.length-1].$id == props.item.$id">
              <td class="text-xs-right"><strong class="text-primary">DATA DE ABERTURA DA EMPRESA</strong></td>
              <td class="text-xs-left">{{ model.regularidadeFiscTrab[0].dtAberturaEmpresa | dataFormatada }}</td>
              <td class="text-xs-right"></td>
              <td class="text-xs-right"></td>
              <td class="text-xs-right"></td>
              <td class="text-xs-right"></td>
              <td class="text-xs-right"></td>
            </tr>   
            <!-- / Nova linha solicitada no ticket 161107 -->
        </template>
      </v-data-table>
    </v-card>
  </v-flex>
</v-layout>

  </div>
</template>
<script>
import fornecedorService from "../../../services/fornecedorService";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
export default {
  name: "resumo-regularidade-fiscal",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    dominio:Object,
    enums:Object,
  },
  created() /*Metodo de start do componente*/{

  },
  data() {//Declaracao de variaveis
    return {
      showBox:true,
      headers:[ {
          text: "",
          align: "right",
          sortable: false,
          width: 300
        },
        {
          text: "Nº Doc.",
          align: "left",
          sortable: false,
          width: 100
        },
        {
          text: "Situação",
          align: "left",
          sortable: false,
          width: 300
        },
        {
          text: "Dt. Emissão",
          align: "center",
          sortable: false,

        },
        {
          text: "Dt. Validade",
          align: "center",
          sortable: false,

        },
        {
          text: "Cód. Controle",
          align: "left",
          sortable: false,

        },
        {
          text: "Anexo",
          align: "left",
          sortable: false,
          class:"naoImprimir"

        },
      ]
    };
    
  },
  methods: {//Declaracao de todos os metodos
 
    handleIconClick(arquivo,situacao) {
    if (arquivo.includes('https')) {
      window.open(arquivo, '_blank');
    } else if (situacao === 1 && arquivo.includes('.pdf')) {
      this.baixarArquivo(arquivo);
    }
  },
  deveSerVermelho(item) {
    const tiposPermitidos = [5, 6, 4];
    const descricaoSituacao = this.retornaEnumDescricao("situacaoDoc", item.situacaoDoc);
    
    return tiposPermitidos.includes(item.tipDocumento) && descricaoSituacao === "Positiva";
  },
  baixarArquivo(arquivo) {
        //baixar o documento
       
      const numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g, "") ;
         
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
      },
  openBox(){
    //abrir o box com os documentos
    this.showBox=!this.showBox;
  },
    retornaTipoQualificacao(tipoQualificacao){
      //retorna o tipo de qualificacao
    if (!tipoQualificacao || !this.enums.tipoQualificacao) return ''
    let tpQualificacao = this.enums.tipoQualificacao.find(x=>x.valor===tipoQualificacao);
    return tpQualificacao ? tpQualificacao.descricao : null;
  },
  retornaEnumDescricao(_enum,valor){
    //retornar a descricao do enum
    if (!valor || !this.enums[_enum]) return ''
    let retorno = this.enums[_enum].find(x=>x.valor===valor);
    return retorno ? retorno.descricao : null;
  },

  },
};
</script>

<style scoped> /*CSS especifico do componente*/
.texto-positiva-vermelha {
  color: red !important; /* ou use uma variável de cor, ex: var(--danger) */
}

.infoDados .v-card{
  padding: 15px;
}

.infoDados .linhaInfo{
display: block;
padding: 5px 0;
}

.theme--light.v-table thead{
  background: none;
}

table.tableNovo {
  display: none !important;
}

</style>


